import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { BrandedLayout } from '@/components/BrandedLayout';

/**
 * Auth callback
 *
 * Supabase Auth hands off here after email verification, magic-link click,
 * or password recovery. Supabase JS automatically detects the session in the
 * URL hash and stores it. We then dispatch by the `type` parameter:
 *   - type=recovery   -> /auth/reset (set a new password)
 *   - everything else -> /
 *
 * The PASSWORD_RECOVERY listener in AuthInitializer.tsx is the safety net
 * for recoveries that land at root.
 */
export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const flowType =
        typeof window !== 'undefined'
          ? new URLSearchParams(window.location.hash.replace(/^#/, '')).get('type')
          : null;

      const { data } = await supabase.auth.getSession();
      if (cancelled) return;

      if (!data.session) {
        navigate('/auth/sign-in', {
          replace: true,
          state: {
            error: 'We could not complete the verification. The link may have expired or already been used.',
          },
        });
        return;
      }

      if (flowType === 'recovery') {
        navigate('/auth/reset', { replace: true });
        return;
      }

      navigate('/', { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <BrandedLayout>
      <div className="container mx-auto py-16 px-4 text-center text-sm text-muted-foreground">
        Finishing sign-in...
      </div>
    </BrandedLayout>
  );
}
